import { CountRequest, CountResponse } from "shared/api/api";
import { useAPI, usePaginatedAPI } from "shared/api/hooks";

import {
  countDirectivesRequestURI,
  Directive,
  GetDirectiveRequest,
  getDirectiveRequestURI,
  ListDirectivesRequest,
  listDirectivesRequestURI,
} from "./api";

export const useListDirectives = (args: ListDirectivesRequest) =>
  usePaginatedAPI<typeof args, Directive[]>(listDirectivesRequestURI, args);

export const useCountDirectives = (args: CountRequest) =>
  useAPI<typeof args, CountResponse>(countDirectivesRequestURI, args);

export const useDirective = (args: GetDirectiveRequest) =>
  useAPI<typeof args, Directive>(getDirectiveRequestURI, args);
